module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("REASON & CHARACTER")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("The Moral Foundations of Aristotelian Political Philosophy")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_vm._v("◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("LORRAINE SMITH PANGLE")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_vm._v("◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("The University of Chicago Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("CHICAGO AND LONDON")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f864a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-pangle-reason-0003.vue
// module id = 60
// module chunks = 0